import { createSlice } from '@reduxjs/toolkit';

export const generalConditionsSlice = createSlice({
  name: 'generalConditionsSlice',
  initialState: null,
  reducers: {
    setGeneralConditionsRequest: (state) => state,
    setGeneralConditionsSuccess: (state) => state,
    setGeneralConditionsFailure: (state) => state,
  },
});
